const languages = {
  EN: 'en',
  ES: 'es',
  ZH_HANT: 'zh-Hant',
  ZH_HANS: 'zh-Hans',
} as const;

export default languages;
